(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('ReportPhishingController', ["$scope", "$q", "$location", "path", "modulesManager", "tablePaginationHelper", "objectTypeDao", "$routeParams", "routeHelper", "emailDao", "modals", "remediationProperties", "manualActionDao", "apExceptionsModal", "policyPropertyParser", "defaultListConverter", "columnsHelper", "$timeout", "rolesManager", "fileDao", "http", "appScanStatusHelper", "troubleshooting", function ($scope, $q, $location, path, modulesManager, tablePaginationHelper, objectTypeDao, $routeParams, routeHelper, emailDao, modals, remediationProperties, manualActionDao, apExceptionsModal, policyPropertyParser, defaultListConverter, columnsHelper, $timeout, rolesManager, fileDao, http, appScanStatusHelper, troubleshooting) {
        var converters = {
            attachmentsConverter: function (text, columnId, columnsMap, args) {
                if (!text || !text.length) {
                    return '';
                }
                var maxInlineCount = 3;
                var inlineCount = text.length > maxInlineCount ? maxInlineCount - 1 : text.length;
                var maxTipCount = 10;
                var result = _(text).chain().first(inlineCount).map(function (file) {
                    return '#' + JSON.stringify({
                        display: 'link',
                        'class': 'attachment-element',
                        text: file.name,
                        type: 'profile',
                        entityType: file.entity_type,
                        id: file.entity_id,
                        tooltip: {
                            content: { text: file.name },
                            style: { classes: 'qtip-standard max-half-window' },
                            position: {
                                at: 'bottom center',
                                my: 'top center'
                            }
                        }
                    });
                }).value().join('');
                if (text.length > inlineCount) {
                    var tipFiles = _(text).chain().rest(inlineCount).first(maxTipCount).value();
                    var moreText = '';
                    if (inlineCount + tipFiles.length < columnsMap.attachments_count) {
                        moreText = '<div class="white-space-nowrap">' + (columnsMap.attachments_count - inlineCount - tipFiles.length) + ' more</div>';
                    }
                    result += '#' + JSON.stringify({
                        display: 'link',
                        type: 'profile',
                        entityType: args.entityType,
                        id: columnsMap.entity_id,
                        'class': 'attachment-element',
                        text: columnsMap.attachments_count - inlineCount + ' more',
                        tooltip: {
                            content: {
                                text: _(tipFiles).map(function (file) {
                                    return '<div class="white-space-nowrap">' + file.name + '</div>';
                                }).join('') + moreText
                            },
                            position: {
                                at: 'bottom center',
                                my: 'top center',
                                viewport: true
                            }
                        }
                    });
                }
                return result;
            },
            actionsConverter: function (text, columnId, columnsMap, args) {
                var blacklistAction = '';
                var quarantineAction = '';
                var declineAction = '';
                if (columnsMap.report_phishing_blacklisted_at) {
                    blacklistAction = '#' + JSON.stringify({
                        display: 'text',
                        'class': 'display-block',
                        text: 'Block-Listed at ' + columnsMap.report_phishing_blacklisted_at
                    });
                } else if (!columnsMap.report_phishing_declined_at && columnsMap.report_phishing_source) {
                    blacklistAction = '#' + JSON.stringify({
                        display: 'link',
                        'class': 'action-link',
                        text: 'Create Block-List rule',
                        tooltip: 'Mark this email (and similar emails) as phishing',
                        clickEvent: {
                            name: 'add-ap-avanan-blacklist',
                            entityType: args.entityType,
                            entityId: columnsMap.entity_id
                        }
                    });
                }
                if (columnsMap.quarantined_at) {
                    quarantineAction = '#' + JSON.stringify({
                        display: 'text',
                        'class': 'display-block',
                        text: 'Quarantined at ' + columnsMap.quarantined_at
                    });
                } else if (!columnsMap.report_phishing_declined_at && columnsMap.report_phishing_source) {
                    quarantineAction = '#' + JSON.stringify({
                        display: 'link',
                        'class': 'action-link',
                        text: 'Quarantine',
                        tooltip: 'Quarantine',
                        clickEvent: {
                            name: 'report-phishing-quarantine',
                            entityId: columnsMap.entity_id
                        }
                    });
                }
                if (columnsMap.report_phishing_declined_at) {
                    declineAction = '#' + JSON.stringify({
                        display: 'text',
                        'class': 'display-block',
                        text: 'Declined at ' + columnsMap.report_phishing_declined_at
                    });
                } else if (!columnsMap.quarantined_at && columnsMap.report_phishing_source) {
                    declineAction = '#' + JSON.stringify({
                        display: 'link',
                        'class': 'action-link',
                        text: 'Decline',
                        tooltip: 'Decline',
                        clickEvent: {
                            name: 'report-phishing-decline',
                            entityId: columnsMap.entity_id
                        }
                    });
                }
                return blacklistAction + quarantineAction + declineAction;
            }
        };
        $scope.enabledSaases = [];
        $scope.model = { currentModule: $routeParams.module };
        var availableSaases = ['office365_emails'];
        modulesManager.init().then(function () {
            $scope.enabledSaases = _(modulesManager.activeSaasApps()).filter(function (saas) {
                return _(availableSaases).contains(saas.name);
            }).map(function (saas) {
                return $.extend({ href: routeHelper.getHref('report-phishing', { module: saas.name }) }, saas);
            });
        });
        var objectTypesPromise = objectTypeDao.retrieve(false);
        $scope.reload = function () {
            $scope.debugEnabled = troubleshooting.entityDebugEnabled();
            $scope.processingActions = {};
            if ($scope.tableHelper) {
                $scope.tableHelper.destroy();
            }
            if ($scope.enabledSaases.length) {
                var currentModuleEnabled = _($scope.enabledSaases).find(function (saas) {
                    return saas.name === $scope.model.currentModule;
                });
                if (!currentModuleEnabled) {
                    routeHelper.redirectTo('report-phishing', { module: $scope.enabledSaases[0].name });
                    return;
                }
            } else {
                return $timeout(function () {
                    $scope.reload();
                }, 1000);
            }
            $scope.tableOptions = {
                pagesAround: 2,
                pageSize: 20,
                pagination: {
                    page: 1,
                    ordering: {}
                },
                asDivs: true,
                infinite: true,
                reloadUuid: true,
                saveState: true,
                showWorkingIndicator: true,
                disableTop: true,
                orderDisplayMode: 'highlight-column',
                dropdownHeader: true,
                actions: [
                    {
                        label: 'Quarantine...',
                        display: 'button',
                        active: function () {
                            return $scope.tableHelper.getSelectedIds().length > 0;
                        },
                        execute: function () {
                            executeAction('quarantine', $scope.tableHelper.getSelectedIds(), true);
                        }
                    },
                    {
                        label: 'Decline...',
                        display: 'button',
                        active: function () {
                            return $scope.tableHelper.getSelectedIds().length > 0;
                        },
                        execute: function () {
                            executeAction('decline_report_phishing', $scope.tableHelper.getSelectedIds(), true);
                        }
                    }
                ]
            };
            $q.all([
                objectTypesPromise,
                path('gui-v2').ctrl('report-phishing').json($scope.model.currentModule + '.report-phishing').retrieve()
            ]).then(function (responses) {
                var config = responses[1].data;
                $scope.options = {
                    columns: config.columns,
                    options: $.extend({
                        enableCheckbox: function (row, model) {
                            var repPhishSrcCol = columnsHelper.getIdxByIdStrict(model.columns, 'report_phishing_source');
                            var quarantinedAtCol = columnsHelper.getIdxByIdStrict(model.columns, 'quarantined_at');
                            var reportPhishingDeclinedAtCol = columnsHelper.getIdxByIdStrict(model.columns, 'report_phishing_declined_at');
                            if (!repPhishSrcCol || !quarantinedAtCol || !reportPhishingDeclinedAtCol) {
                                return false;
                            }
                            if (!row[repPhishSrcCol].originalText) {
                                return false;
                            }
                            return !(row[quarantinedAtCol].originalText || row[reportPhishingDeclinedAtCol].originalText);
                        }
                    }, config.options)
                };
                $scope.entityType = config.entityType;
                $scope.sources = responses[0].data.sources($scope.entityType);
                $scope.actionTypes = responses[0].data.actionTypes[$scope.entityType];
                $scope.actions = {
                    'quarantine': {
                        action: _($scope.actionTypes).find(function (action) {
                            return action.id === config.quarantineActionId;
                        }),
                        confirmText: function (ids) {
                            return ids.length + ' email' + (ids.length === 1 ? '' : 's') + ' will be quarantined.';
                        }
                    },
                    'decline_report_phishing': {
                        action: _($scope.actionTypes).find(function (action) {
                            return action.id === config.declineActionId;
                        }),
                        confirmText: function (ids) {
                            return ids.length + ' user' + (ids.length === 1 ? '' : 's') + ' reported phishing will be declined.';
                        }
                    }
                };
                $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                    args.columnsFilters = $.extend({
                        debug_mode: [{
                                data: $scope.debugEnabled === true ? '1' : '0',
                                operator: '=',
                                type: 'textEqual'
                            }]
                    }, args.columnsFilters);
                    // I'll let this commented because we may return to this later
                    /*
                args.columnsFilters = $.extend({
                    ReceivedDateTime_filter: [
                        {
                            data: moment.utc().subtract(2, 'weeks').format('YYYY-MM-DD HH:mm:ss'),
                            not: false,
                            operator: '>=',
                            type: 'date'
                        }]
                }, args.columnsFilters);
                 */
                    var q = emailDao.phishingReports($scope.options.columns).converter(defaultListConverter, function () {
                        return {
                            columns: $scope.options.columns,
                            converters: converters
                        };
                    });
                    q.params(columnsHelper.filtersToParams(args.columnsFilters));
                    return q.pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order, _(args.ordering.columnName.split(',')).map(function () {
                        return 'last';
                    }).join(','));
                }, function (tableModel) {
                    $scope.tableModel = tableModel;
                    var nrows = $scope.tableHelper.getTotal();
                    $scope.tableOptions.infoText = nrows + ' user' + (nrows === 1 ? '' : 's') + ' reported phishing';
                    updateRowClasses();
                });
                $scope.options.options.checkboxes = rolesManager.isActionAllowed([
                    'admin',
                    'user',
                    'operations'
                ]) ? true : false;
            });
        };
        function executeAction(actionType, ids, alwaysConfirm) {
            var actionDef = $scope.actions[actionType];
            var action = actionDef.action;
            var params = _(action.attributes).chain().filter(function (param) {
                return _(param.label).isString();
            }).map(function (param) {
                return $.extend(true, {}, param);
            }).value();
            var getProperties = _.memoize(remediationProperties($scope.sources.properties));
            if (alwaysConfirm || ids.length > 1) {
                params.push({
                    type: 'message',
                    message: '#' + JSON.stringify({
                        display: 'text',
                        'class': 'display-block',
                        text: actionDef.confirmText(ids)
                    }) + '#' + JSON.stringify({
                        display: 'text',
                        'class': 'display-block',
                        text: 'Are you sure you want to continue?'
                    }),
                    paramClass: 'full-width-param'
                });
            }
            var visibleParam = _(params).find(function (param) {
                if (param.type !== 'property') {
                    return true;
                }
                var properties = getProperties(param.propertyType);
                if (properties[0].sub.length !== 1) {
                    return true;
                }
                if (properties[properties[0].sub[0]].selectable) {
                    return false;
                }
                return true;
            });
            var p;
            if (visibleParam) {
                p = modals.params([{
                        params: params,
                        lastPage: true,
                        getProperties: getProperties
                    }], action.label, '', { noDataLabel: action.confirm });
            } else {
                p = $q.when(_(params).chain().map(function (param) {
                    if (!param.id) {
                        return;
                    }
                    var data = param.data;
                    if (param.type === 'property') {
                        var properties = getProperties(param.propertyType);
                        if (properties[0].sub.length == 1) {
                            var firstProperty = properties[_(properties[0].sub).first()];
                            if (firstProperty.selectable) {
                                data = firstProperty.id;
                            }
                        }
                        if (_(data).isString()) {
                            data = data.replace(/^\{/, '').replace(/}$/, '');
                            if (data.length) {
                                data = '.' + data;
                            }
                        }
                        data = policyPropertyParser(data);
                        if (_(data.fullId).isString()) {
                            if (data.fullId[0] == '.') {
                                data = '{' + data.fullId.slice(1) + '}';
                            } else {
                                data = '{' + data.fullId + '}';
                            }
                        } else {
                            data = undefined;
                        }
                    }
                    return [
                        param.id,
                        data
                    ];
                }).compact().object().value());
            }
            p.then(function (data) {
                var body = {
                    name: action.id,
                    attributes: data
                };
                var extendedAttributesActions = {
                    office365_emails_decline_report_phishing: {
                        label: '',
                        title: 'Decline reason',
                        type: 'text',
                        id: 'report_phishing_decline_reason'
                    }
                };
                if (action.id && extendedAttributesActions[action.id]) {
                    return modals.params([{
                            lastPage: true,
                            params: [extendedAttributesActions[action.id]]
                        }], extendedAttributesActions[action.id].title || 'Extended Attributes', 'sm', { windowClass: 'modal-params__extended_attributes' }).then(function (d) {
                        body.extended_attributes = d;
                        addToUpdater(ids);
                        updateRowClasses();
                        $scope.tableHelper.clearSelection();
                        manualActionDao.create($scope.entityType, ids, body).then(function () {
                            updateEmails();
                        });
                    });
                } else {
                    addToUpdater(ids);
                    updateRowClasses();
                    $scope.tableHelper.clearSelection();
                    manualActionDao.create($scope.entityType, ids, body).then(function () {
                        updateEmails();
                    });
                }
            });
        }
        function updateRowClasses() {
            if (!$scope.tableModel || !$scope.tableModel.data) {
                return;
            }
            var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
            _($scope.tableModel.data).each(function (row, idx) {
                $scope.tableModel.rowClasses[idx] = $scope.tableModel.rowClasses[idx] || {};
                if ($scope.processingActions[row[primaryColumn].originalText]) {
                    $scope.tableModel.rowClasses[idx].processing = true;
                } else {
                    delete $scope.tableModel.rowClasses[idx].processing;
                }
            });
        }
        function addToUpdater(ids) {
            if (!$scope.tableModel || !$scope.tableModel.data) {
                return;
            }
            var idsMap = _(ids).chain().map(function (id) {
                return [
                    id,
                    {}
                ];
            }).object().value();
            var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
            _($scope.tableModel.data).each(function (row) {
                if (!idsMap[row[primaryColumn].originalText]) {
                    return;
                }
                idsMap[row[primaryColumn].originalText].old = row;
            });
            _(idsMap).each(function (data, id) {
                if (data.old) {
                    $scope.processingActions[id] = {
                        updated: moment(),
                        old: angular.copy(data.old)
                    };
                }
            });
        }
        var statusUpdateTimer = false;
        function rowMatchesFilters(row) {
            // always keep the row to show the status after the action is executed
            return true;
        }
        function updateEmails() {
            if (statusUpdateTimer && _($scope.processingActions).isEmpty()) {
                $timeout.cancel(statusUpdateTimer);
                statusUpdateTimer = false;
            }
            var interval = 2000;
            var expiredTime = moment().subtract(60, 'seconds');
            var needRefresh = [];
            $scope.processingActions = _($scope.processingActions).pick(function (data, id) {
                if (data.updated.isBefore(expiredTime)) {
                    return false;
                }
                needRefresh.push(id);
                return true;
            });
            if (needRefresh.length) {
                emailDao.phishingReports().params({ entity_id: needRefresh.join(',') }).converter(defaultListConverter, function () {
                    return {
                        columns: $scope.options.columns,
                        converters: converters
                    };
                }).then(function (request) {
                    var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
                    var fetchedIds = {};
                    _(request.data.data).each(function (row) {
                        var primaryId = row[primaryColumn].originalText;
                        var processing = $scope.processingActions[primaryId];
                        if (processing) {
                            fetchedIds[primaryId] = true;
                            if (!angular.equals(processing.old, row)) {
                                if ($scope.tableModel) {
                                    var rowIndex = _($scope.tableModel.data).findIndex(function (existingRow) {
                                        return existingRow[primaryColumn].originalText === primaryId;
                                    });
                                    if (rowIndex > -1) {
                                        $scope.tableModel.data[rowIndex] = row;
                                    }
                                }
                                delete $scope.processingActions[primaryId];
                            }
                        }
                    });
                    _($scope.processingActions).each(function (value, id) {
                        if (!fetchedIds[id]) {
                            var idx = _($scope.tableModel.data).findIndex(function (row) {
                                return row[primaryColumn].originalText === id;
                            });
                            if (idx !== -1) {
                                delete $scope.tableModel.rowClasses[idx].processing;
                                $scope.tableModel.data.splice(idx, 1);
                                delete $scope.processingActions[id];
                                if ($scope.tableHelper.getTotal() > 0) {
                                    $scope.tableOptions.infoText = $scope.tableHelper.getTotal() - 1 + ' requests';
                                }
                            }
                        }
                    });
                    updateRowClasses();
                    statusUpdateTimer = $timeout(updateEmails, interval);
                });
            }
        }
        $scope.reload();
        $scope.$watch('model.currentModule', function (newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            routeHelper.redirectTo('report-phishing', { module: $scope.model.currentModule }, { replace: true });
        });
        $scope.$on('report-phishing-quarantine', function (event, data) {
            executeAction('quarantine', [data.entityId]);
        });
        $scope.$on('report-phishing-decline', function (event, data) {
            executeAction('decline_report_phishing', [data.entityId]);
        });
        $scope.$on('add-ap-avanan-blacklist', function (event, data) {
            $q.allSettled([
                http.get('/api/v1/apps/statistics').params({
                    entity_id: data.entityId,
                    entity_type: data.entityType
                }),
                http.get('/api/v1/apps/sec_entities').params({
                    entity_id: data.entityId,
                    entity_type: data.entityType
                })
            ]).then(function (responses) {
                var apStatistics = responses[0] && responses[0].value && responses[0].value.data && responses[0].value.data.ap_avanan;
                var apScanDetails = responses[1] && responses[1].value && responses[1].value.data && responses[1].value.data.ap_avanan;
                var scanStatus = appScanStatusHelper.statisticsToStatus(apStatistics, 'ap_avanan', apScanDetails);
                return apExceptionsModal.show({
                    entityType: data.entityType,
                    entityId: data.entityId,
                    scanStatus: scanStatus,
                    type: 'blacklist'
                }).then(function () {
                    $scope.tableHelper.clearSelection();
                });
            });
        });
    }]);
}());